import * as angular from "angular";
import {IController} from "angular";
import {ContactPersonModel} from "../../models/contact-person.model";

export class ContactPersonListComponent implements IController {
  contacts: ContactPersonModel[];
  canRemove?: boolean;
  onChange: Function;

  constructor() {
  }

  $onInit() {
  }

  onAddContact() {
    if (!this.contacts) {
      this.contacts = [];
    }
    this.contacts.push({});
    this.onChange({contacts: this.contacts});
  }

  onRemoveContact(index) {
    this.contacts.splice(index, 1);
    this.onChange({contacts: this.contacts});
  }

  onFieldChange() {
    this.onChange({contacts: this.contacts});
  }

}

angular
  .module('bringoz.admin.commons')
  .component('contactPersonList', {
    require: {
      form: '^form'
    },
    bindings: {
      contacts: '<',
      canRemove: '<?',
      onChange: '&',
    },
    template: require('./contact-person-list.html').default,
    controller: ContactPersonListComponent
  });
